export const identity = <T>(it: T): T => it
